import { useRoutes, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
// PC端页面导入
import Home from '@/pages/Home/index';
import Agents from '@/pages/Agents/index';
// import Xiabao from '@/pages/Xiabao/index';
import ExplainAgent from '@/pages/ExplainAgent/index';
import About from '@/pages/About/index';
import Join from '@/pages/Join/index';
import Download from '@/pages/Download/index';
import Matrix from '@/pages/Matrix/index';
import Tutor from '@/pages/Tutor/index';
import NotFound from '@/pages/NotFound';

export default function Router() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // PC端路由配置
  const route = [
    { path: '/', element: <Home /> },
    { path: '/aixue-ai', element: <Agents /> },
    { path: '/aixue-phonics', element: <Matrix /> },
    // { path: '/aixue-xiabao', element: <Xiabao /> },
    { path: '/aixue-explain', element: <ExplainAgent /> },
    { path: '/aixue-guide', element: <Tutor /> },
    { path: '/aixue-about', element: <About /> },
    { path: '/aixue-join', element: <Join /> },
    { path: '/aixue-download', element: <Download /> },
    { path: '/aixue-matrix', element: <Navigate to="/aixue-phonics" replace /> },
    {
      path: '/404',
      element: <NotFound />,
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ];

  // 根据设备类型选择路由
  const routes = useRoutes(route);

  return routes;
}
